import http from "../../../utils/fetch";

export default {
    baseurl:'/api/swyl/v1/demo/bscNetworkMeeting',
    baseurl2026:'/api/swyl/v1/demo/bscNetworkMeeting2026',
    //分页查询
    selectPage(f) {
        return http({
            url: this.baseurl+'/selectPage',
            method: 'get',
            params: f
        });
    },
    //查询区域代理商
    selectMeetUserList () {
        return http({
            url: this.baseurl+'/selectMeetUserList',
            method: 'get'
        });
    },
    //选择代理商带出需要的信息
    selectUserInfo(q){
        return http({
            url: this.baseurl+'/selectUserInfo',
            method: 'get',
            params: q
        });
    },
    //根据id查看详情
    selectById(q){
        return http({
            url: this.baseurl+'/selectById?id=' + q,
            method: 'get'
        });
    },
    //保存提交
    insert(f){
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            data: f
        });
    },
    //修改保存
    updateById (f){
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            data: f
        });
    },
    //根据时间查询
    selectByWeek(f){
        return http({
            url: this.baseurl+'/selectByWeek',
            method: 'get',
            params: f
        });
    },
    //列表导出
    downloadExcelList(data){
        return http({
            url: this.baseurl+'/downloadExcel',
            method: 'get',
            params: data,
            responseType: 'blob',
        });
    },
    //需要删除用户列表
    selectPageDetailList(data){
        return http({
            url:'/api/swyl/v1/demo/bscNetworkMeetingPlanDetail/selectPage',
            method: 'post',
            params: data,
        })
    },
    //需要删除用户列表导出
    pageDetailExport(data){
        return http({
            url: '/api/swyl/v1/demo/bscNetworkMeetingPlanDetail/downloadExcel',
            method: 'get',
            params: data,
            responseType: 'blob',
        })
    },
    selectMeetingReportFile(query) {
        return http({
            url: this.baseurl+'/selectNetworkReportFile',
            method: 'post',
            params: query
        });
    },

    //新增运营会---------------------------------------2026---------------------------------

    checkUserIsSign(customerName,year){
        return http({
            url: this.baseurl2026+'/checkUserIsSign',
            method: 'get',
            params: {customerName:customerName,year:year}
        });
    },

    //选择代理商带出需要的信息
    selectUserInfo2026(q){
        return http({
            url: this.baseurl2026+'/selectUserInfo',
            method: 'get',
            params: q
        });
    },
    selectPage2026(f) {
        return http({
            url: this.baseurl2026+'/selectPage',
            method: 'get',
            params: f
        });
    },
    //列表导出
    downloadExcelList2026(data){
        return http({
            url: this.baseurl2026+'/downloadExcel',
            method: 'get',
            params: data,
            responseType: 'blob',
        });
    },
    //保存提交
    insert2026(f){
        return http({
            url: this.baseurl2026+'/insert',
            method: 'post',
            data: f
        });
    },
    //根据id查看详情
    selectById2026(q){
        return http({
            url: this.baseurl2026+'/selectById?id=' + q,
            method: 'get'
        });
    },
    selectDetailById(q){
        return http({
            url: this.baseurl2026+'/selectDetailById?id=' + q,
            method: 'get'
        });
    },


    updateById2026(f){
        return http({
            url: this.baseurl2026+'/updateById',
            method: 'post',
            data: f
        });
    },
    // 评价
    evaluate2026(query) {
        return http({
            url: this.baseurl2026 + '/evaluate',
            method: 'post',
            params: query
        });
    }
}
